/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.adminModule', ['ui.router', 'bulbApp.authModule', 'bulbApp.configModule'])
.config(['$stateProvider', 'AUTH', function($stateProvider, AUTH) {
  $stateProvider
    .state('admin', {
      parent: 'bulbView',
      url: '^/b/admin',
            resolve: {
                maintenanceAlert: ['Restangular', (Restangular) => Restangular.one('admin/maintenance_alert').get()],
        $title: ['$translate', ($translate) => $translate('admin_title')]
            },
      views: {
        'bulbView': {
          templateUrl: 'ajs/admin/admin.html',
                    controller: 'AdminController as adminCtrl'
        }
      },
      bulbAuth: {
        authorizedRoles: [AUTH.ROLES.ADMIN]
      }
    });
}]);
